import { cx } from '@emotion/css';

import Button, { ButtonTypes } from '../../Button';
import Error from '../../Error';
import withControl, { WithControlRenderProps } from '../withControl';

import messages from './messages.json';
import {
  bodyClassName,
  buttonPrimaryClassName,
  buttonSecondaryClassName,
  collapsibleClassName,
  dangerClassName,
  descriptionClassName,
  disabledPrimaryButtonClassName,
  disabledSecondaryButtonClassName,
  errorClassName,
  footerClassName,
  headClassName,
  headerClassName,
  headingClassName,
  rightHeaderClassName,
  subheaderClassName,
} from './styles';
import { CollapsibleProps } from './types';

type Props = CollapsibleProps & WithControlRenderProps;

const Collapsible = ({
  description,
  error,
  isActive,
  isDirty,
  isDisabled,
  isSaving,
  children,
  className = '',
  hidden,
  label,
  onCancel,
  onEdit,
  onSave,
  ref,
  value,
}: Props) => {
  return (
    <div
      className={cx(collapsibleClassName, { [className]: !!className })}
      ref={ref}
    >
      <div
        className={cx({ [headClassName]: (!hidden && !!value) || !!isActive })}
      >
        <div className={headerClassName}>
          <span
            className={cx(headingClassName, { [dangerClassName]: !!error })}
          >
            {label}
          </span>
          <div className={rightHeaderClassName}>
            <Button
              className={cx(buttonSecondaryClassName, {
                [disabledSecondaryButtonClassName]: isDisabled,
              })}
              disabled={isDisabled}
              onClick={isActive ? onCancel : onEdit}
            >
              {isActive ? messages.buttonCancelLabel : messages.buttonEditLabel}
            </Button>
          </div>
        </div>
        {isActive && description && (
          <div className={subheaderClassName}>
            <span className={descriptionClassName}>{description}</span>
          </div>
        )}
      </div>
      <div className={bodyClassName}>
        {!isActive ? (!!hidden ? undefined : value) : children}
      </div>
      {isActive && (
        <div className={footerClassName}>
          <Button
            className={cx(buttonPrimaryClassName, {
              [disabledPrimaryButtonClassName]: !isDirty,
            })}
            disabled={!isDirty || isSaving}
            loading={isSaving}
            onClick={onSave}
            type={ButtonTypes.Submit}
          >
            {messages.buttonSaveLabel}
          </Button>
          {!!error && (
            <Error className={errorClassName} message={error.message} />
          )}
        </div>
      )}
    </div>
  );
};

Collapsible.displayName = 'Collapsible';

export default withControl(Collapsible);
